import { render } from "./PositionTreeNode.vue?vue&type=template&id=080081a8&scoped=true"
import script from "./PositionTreeNode.vue?vue&type=script&lang=js"
export * from "./PositionTreeNode.vue?vue&type=script&lang=js"

import "./PositionTreeNode.vue?vue&type=style&index=0&id=080081a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080081a8"]])

export default __exports__